<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="layout--main" :class="[layoutTypeClass, navbarClasses, {'no-scroll': isAppPage}]">
        <div id="work-space">
            <div class="relative">

                <div class="navbar-full">
                    <vs-navbar class="navbar-custom navbar-skelton" :color="navbarColorLocal"
                               :class="textColor"
                               style="background-color: rgba(var(--vs-primary),1)">
                        <!-- SM - OPEN SIDEBAR BUTTON -->
                        <img src="../../assets/images/logo/dr.hoangtuan(cam-trang).png" alt="" height="50"
                             class="cursor-pointer" @click="redirectToHomePage">
                        <vs-spacer/>
                        <div v-if="!token">
                            <vs-button class="" color="warning" type="border" @click="$router.push('/pages/register')">
                                Đăng ký
                            </vs-button>
                            <vs-button class="ml-2" color="warning" @click="$router.push('/pages/login')">Đăng nhập
                            </vs-button>
                        </div>
                        <profile-drop-down v-else/>

                    </vs-navbar>
                </div>
            </div>
            <!-- /Navbar -->
            <div class="layout--full-page">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>


<script>
import HNavMenu from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import themeConfig from '@/../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import ProfileDropDown from "../../layouts/components/navbar/components/ProfileDropDown"

export default {
    components: {
        HNavMenu,
        TheNavbarHorizontal,
        TheNavbarVertical,
        VNavMenu,
        ProfileDropDown
    },
    data() {
        return {
            hideScrollToTop: themeConfig.hideScrollToTop,
            isNavbarDark: false,
            navbarColor: themeConfig.navbarColor || '#fff',
            navbarType: themeConfig.navbarType || 'floating',
            routerTransition: themeConfig.routerTransition || 'none',
            routeTitle: this.$route.meta.pageTitle,
            token: null,
        }
    },
    watch: {
        "$route"() {
            this.routeTitle = this.$route.meta.pageTitle
        },
        isThemeDark(val) {
            const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
            this.updateNavbarColor(color)
        },
        "$store.state.mainLayoutType"(val) {
            this.setNavMenuVisibility(val)
        }
    },
    computed: {
        navbarColorLocal() {
            return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
        },
        textColor() {
            return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
        },
        contentAreaClass() {
            if (this.mainLayoutType === "vertical") {
                if (this.verticalNavMenuWidth == "default") return "content-area-reduced"
                else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
                else return "content-area-full"
            } else if (this.mainLayoutType === "boxed") return "content-area-reduced"
            else return "content-area-full"
        },
        isAppPage() {
            return this.$route.meta.no_scroll
        },
        isThemeDark() {
            return this.$store.state.theme == 'dark'
        },
        layoutTypeClass() {
            return `main-${this.mainLayoutType}`
        },
        mainLayoutType() {
            return this.$store.state.mainLayoutType
        },
        navbarClasses() {
            return {
                'navbar-hidden': this.navbarType == 'hidden',
                'navbar-sticky': this.navbarType == 'sticky',
                'navbar-static': this.navbarType == 'static',
                'navbar-floating': this.navbarType == 'floating',
            }
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },
    },
    methods: {
        changeRouteTitle(title) {
            this.routeTitle = title
        },
        updateNavbar(val) {
            if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
            this.navbarType = val
        },
        updateNavbarColor(val) {
            this.navbarColor = val
            if (val == "#fff") this.isNavbarDark = false
            else this.isNavbarDark = true
        },
        setNavMenuVisibility(layoutType) {
            if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
                this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
            } else {
                this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
            }
        },
        toggleHideScrollToTop(val) {
            this.hideScrollToTop = val
        },

        redirectToHomePage() {
            let space = localStorage.getItem('work_space');
            if (space === 'hrm') return this.$router.push('/dashboard-hrm').catch(() => {
            });
            if (space === 'crm') return this.$router.push('/dashboard-crm').catch(() => {
            });
        },
    },
    created() {
        this.token = localStorage.getItem('access_token');
        const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
        this.updateNavbarColor(color)
        this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    }
}

</script>
<style>
#work-space .main-vertical .vx-navbar-wrapper {
    /*width: 100% !important;*/
}
</style>

